import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Children {
  newPadding?: string
}

export const Modal = styled.div`
  width: ${(props: any) => {
    if (props.height) return props.height
    return '95%'
  }};
  height: ${(props: any) => {
    if (props.height) return props.height
    return '95%'
  }};
  border: 0;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 0px 3px 4px 0px #00000040;
  display: flex;
  justify-content: space-between;
`

export const ChildrenContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  height: 100%;
  /* padding: 50px; */
  padding: ${(props: Children) => {
    if (props.newPadding) return props.newPadding
    return '50px'
  }};
  display: flex;
  flex-direction: column;
  /* position: relative; */
  border-radius: 10px;
`

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;

  ::-webkit-scrollbar-track {
    margin-top: 20px;
    background-color: #f4f4f4;
  }
  ::-webkit-scrollbar {
    margin-top: 20px;
    width: 6px;
    background: #f4f4f4;
  }
  ::-webkit-scrollbar-thumb {
    background: #dad7d7;
  }
`

export const Background = styled.div`
  z-index: 205;
  background: #00000026;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PathContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  max-height: 24px;

  margin-bottom: 20px;

  .close-modal {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .path {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #9c948c;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.14px;
  }
`
